import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#end region
//#region components
import { Icon } from "components/common";
import { Badge, Grid } from "@mui/material";
import useShowCommentsDialog from "../useShowCommentsDialog";
//#endregion
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { TimeReportCommentProps } from "models/propTypes/timeReportingPropTypes";
//#endregion
import clsx from "clsx";
import cssExports from "theme/styles/main.module.scss";

const CommentsCount: React.FC<TimeReportCommentProps> = (props) => {
  const { commentsCount, projectTimeId } = props;
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const { getCommentsDialog } = useShowCommentsDialog();
  const onClick = async (e?: React.MouseEvent) => {
    if (projectTimeId) {
      dispatch(displayDialog(getCommentsDialog(projectTimeId)));
    }
  };

  return commentsCount ? (
    <Grid item onClick={onClick} className={clsx(cssExports.cursorPointer)}>
      <Badge badgeContent={commentsCount} classes={{ badge: cssExports.smallBadge }} max={99} overlap="circular">
        <Icon className={clsx(cssExports.commentBubble)} icon={IconDefinitionConstants.WCommentDots} />
      </Badge>
    </Grid>
  ) : (
    <></>
  );
};

export default CommentsCount;
